import { render, staticRenderFns } from "./CampoEmail.vue?vue&type=template&id=2ebbf4cc&scoped=true&"
import script from "./CampoEmail.vue?vue&type=script&lang=js&"
export * from "./CampoEmail.vue?vue&type=script&lang=js&"
import style0 from "./CampoEmail.vue?vue&type=style&index=0&id=2ebbf4cc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ebbf4cc",
  null
  
)

export default component.exports